<template>
    <div class="container-table">
      <q-card-section>
        <q-table
          data-cy="usuarios-table"
          :data="data"
          :columns="columns"
          row-key="id"
          :pagination.sync="pagination"
          :loading="isLoadingDirect!= null ? isLoadingDirect: isLoading"
        >
        <template v-slot:body-cell-name="props">
            <q-td data-cy="usuarios-name" key="name" :props="props">
                {{ props.row.name + ' ' + props.row.surNames }}
            </q-td>
          </template>
          <template v-slot:body-cell-eliminar="props">
            <q-td key="eliminar" :props="props">
                <q-icon
                  data-cy="bDeleteUser"
                  name="o_delete"
                  style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
                  @click="triggerDelete(props.row)"
                />
              </q-td>
          </template>
        </q-table>
        </q-card-section>
        <DialogDelete
          v-if="rowSelectedtoDelete"
          v-model="showDialogDelete"
          dataCy="delete-user"
          :showIcon="true"
          :txtContainer="`¿Está seguro de eliminar al usuario ${rowSelectedtoDelete.name} ${rowSelectedtoDelete.surNames}?`"
          @save="deleteUser()"
        />
    </div>
</template>
<script>

import {
  QTable,
  QTd,
  QCardSection
} from 'quasar';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';
import Validation from '@/components/shared/mixins/Validation.js';

export default {
  components: {
    QTable,
    QTd,
    QCardSection,
    DialogDelete
  },
  mixins: [Validation, Loading],
  props: {
    dataUsuarios: Array,
    isLoading: Boolean,
    showDeleteButton: {
      required: false,
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    dataUsuarios () {
      this.data = this.dataUsuarios !== null && this.dataUsuarios !== undefined ? this.dataUsuarios : null;
    }
  },
  data () {
    return {
      showDialogDelete: false,
      rowSelectedtoDelete: null,
      isLoadingDirect: null,
      pagination: {
        rowsPerPage: 7
      },
      data: this.dataUsuarios,
      columns: [
        {
          name: 'name',
          label: 'Nombre',
          align: 'left',
          field: 'visible',
          sortable: true
        },
        {
          name: 'eliminar',
          label: 'Eliminar',
          align: 'center',
          field: '',
          sortable: false
        }
      ]
    };
  },
  methods: {
    triggerDelete (row) {
      this.rowSelectedtoDelete = row;
      this.showDialogDelete = true;
    },
    deleteUser () {
      // obtenemos indice
      const index = this.dataUsuarios.indexOf(this.rowSelectedtoDelete);
      // eliminamos el elemento
      this.dataUsuarios.splice(index, 1);
      this.showDialogDelete = false;
      this.$store.commit(types.MUTATE_ALL_USUARIOS, this.dataUsuarios);

      this.$eventHub.$emit('viewEdited');
    }
  }
};
</script>
<style lang="scss" scoped>
button.q-btn.imgBtn{
  margin-left: 0px !important;
  margin-right: 15px;
}
.container-table {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
  }
}
</style>
